export const BANK_DETAILS_PENDING = 'BANK_DETAILS_PENDING';
export const BANK_DETAILS_SUCCESS = 'BANK_DETAILS_SUCCESS';
export const BANK_DETAILS_FAILED = 'BANK_DETAILS_FAILED';

export const SUBMIT_BANK_DETAILS_PENDING = 'SUBMIT_BANK_DETAILS_PENDING';
export const SUBMIT_BANK_DETAILS_SUCCESS = 'SUBMIT_BANK_DETAILS_SUCCESS';
export const SUBMIT_BANK_DETAILS_FAILED = 'SUBMIT_BANK_DETAILS_FAILED';

export const UNMOUNT_BANK_ACCOUNT = 'UNMOUNT_BANK_ACCOUNT';
